import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

interface IProps {
  total: number;
}

const EquipmentByFaultTableSkeleton: React.FC<IProps> = ({ total }) => {
  return [...Array(total)].map(() => (
    <tr key={uuidv4()} className={style.bodyRow}>
      {[...Array(4)].map((_, i) => (
        <td key={uuidv4()}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
      ))}
      <td key={uuidv4()} className={style.iconColumn}>
        <SkeletonBlock className={style.skeletonIcon} />
      </td>
    </tr>
  ));
};

export default EquipmentByFaultTableSkeleton;
